exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-wp-page-uri-tsx": () => import("./../../../src/pages/{WpPage.uri}.tsx" /* webpackChunkName: "component---src-pages-wp-page-uri-tsx" */),
  "component---src-pages-wp-post-uri-tsx": () => import("./../../../src/pages/{WpPost.uri}.tsx" /* webpackChunkName: "component---src-pages-wp-post-uri-tsx" */),
  "component---src-pages-wp-product-uri-tsx": () => import("./../../../src/pages/{WpProduct.uri}.tsx" /* webpackChunkName: "component---src-pages-wp-product-uri-tsx" */)
}

